// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications .alert{position:fixed;z-index:1000}.notifications .alert[data-notify=container]{max-width:460px}.notifications .alert.center{margin:0 -.35%}.notifications .alert.left{left:20px}.notifications .alert.right{right:20px}", ""]);
// Exports
module.exports = exports;
